import React from "react";
//
import { useLocation } from "react-router-dom";
import Form from "../../components/Form";
import Dropdown from "../../components/Form/Dropdown";
import IconInput from "../../components/Form/Input";
//
import { useEffect ,useState} from "react";
import { useHistory } from "react-router-dom";


import { connect } from "react-redux";
import {
  EVALUATION_CREATE,
  SELL_MY_CAR_STEPS,
  TOASTER_SHOW,
  UPDATE_AUTH,
  toaster_w,
} from "../../constant";
import {
  fetchEvaluationProfileContact,
  getMissingEvaluationContactFields,
  getMissingEvaluationVehicleFields,
  pickEvaluationContact,
} from "../../../utils/evaluationContact";
import { POST } from "../../constant/apiMethods";
import Labels from "../../services/apiLabels";
import Step6 from "./Step6";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step7 from "./Step7";
import Step8 from "./Step8";
//
import { scrollTop } from "../../utils/window";
import { upperCase } from "lodash";
import {
  normalizeChoiceField,
  normalizeTextField,
} from "../../utils/sellMyCarFields";
import { getAuth } from "../../services/localStorage";
// 
function EvaluationSteps(props) {
  const {
    currentStep,
    setcurrentStep,
    //
    step1,
    auth,
    //
    setreg_number,
    setmileage,
    setprevious_owners,
    setservices_history,
    //
    setuser_name,
    setuser_email,
    setuser_postcode,
    setuser_mobile_number,
    //
    postEvaluationCreate,
    loading_evaluation_create,
    toasterShow,
    updateAuth,
  } = props;

  // Saved-evaluation screens write raw API values into these keys, so read
  // through normalisers to keep the wizard shape safe.
  const reg_number = normalizeTextField(props.reg_number);
  const mileage = normalizeChoiceField(props.mileage);
  const previous_owners = normalizeChoiceField(props.previous_owners);
  const services_history = normalizeChoiceField(props.services_history);
  const user_name = normalizeTextField(props.user_name);
  const user_email = normalizeTextField(props.user_email);
  const user_postcode = normalizeTextField(props.user_postcode);
  const user_mobile_number = normalizeTextField(props.user_mobile_number);
  const [fieldErrors, setFieldErrors] = useState({});
  const clearFieldError = (key) => {
    setFieldErrors((prev) => {
      if (!prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };
  const showMissingToast = (missing) => {
    if (!missing.length) return;
    toasterShow({
      show: true,
      autoHide: true,
      type: toaster_w,
      description: `Please fill required fields: ${missing.join(", ")}`,
    });
  };
  const formanimationClassname = "animate__animated animate__zoomIn";
  const step2OnSubmitHandler = () => {
    const missing = getMissingEvaluationVehicleFields({
      reg_number,
      mileage,
      previous_owners,
      services_history,
    });
    const nextErrors = {};
    if (!String(reg_number || "").trim()) nextErrors.reg_number = "Required";
    if (!mileage?.isSelected) nextErrors.mileage = "Required";
    if (!previous_owners?.isSelected) nextErrors.previous_owners = "Required";
    if (!services_history?.isSelected) nextErrors.services_history = "Required";
    setFieldErrors(nextErrors);
    if (missing.length) {
      showMissingToast(missing);
      return;
    }
    setcurrentStep(currentStep + 1);
    scrollTop();
  };
  //
  const renderServiceHistoryDetail = (e) => {
    switch (e) {
      case "Full":
        return "All recomended serevices on time ";
      case "Some":
        return "Some recomended serevices are missed ";
      case "None":
        return "No services are done";
      case "First not Due":
        return "Recomended service is due";

      default:
        return "";
    }
  };
  //
  // Autofill contact from auth + profile when entering step 3
  useEffect(() => {
    if (currentStep !== 3 || !auth?.token) return undefined;
    let cancelled = false;
    const contactRef = {
      name: user_name,
      email: user_email,
      mobile: user_mobile_number,
      postcode: user_postcode,
    };
    const applyContact = (contact, { syncAuth = false } = {}) => {
      if (cancelled || !contact) return;
      if (!contactRef.name && contact.name) {
        contactRef.name = contact.name;
        setuser_name(contact.name);
      }
      if (!contactRef.email && contact.email) {
        contactRef.email = contact.email;
        setuser_email(contact.email);
      }
      if (!contactRef.mobile && contact.mobile) {
        contactRef.mobile = contact.mobile;
        setuser_mobile_number(contact.mobile);
      }
      if (!contactRef.postcode && contact.postcode) {
        contactRef.postcode = contact.postcode;
        setuser_postcode(contact.postcode);
      }
      if (syncAuth && (contact.email || contact.mobile || contact.postcode)) {
        updateAuth({
          ...(contact.email ? { email: contact.email } : {}),
          ...(contact.mobile ? { mobile_number: contact.mobile } : {}),
          ...(contact.postcode ? { postcode: contact.postcode } : {}),
        });
      }
    };
    applyContact(pickEvaluationContact(auth));
    fetchEvaluationProfileContact(auth).then((contact) => {
      applyContact(contact, { syncAuth: true });
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, auth?.token, auth?.id]);

  const postEvaluationCreateHandler = () => {
    const contactMissing = getMissingEvaluationContactFields({
      user_name,
      user_email,
      user_postcode,
      user_mobile_number,
    });
    const missing = [];
    if (!step1?.variant?.isSelected) missing.push("Vehicle details");
    if (!reg_number) missing.push("Registration Number");
    if (!mileage?.isSelected) missing.push("Mileage");
    if (!previous_owners?.isSelected) missing.push("Previous Owners");
    if (!services_history?.isSelected) missing.push("Services History");
    missing.push(...contactMissing);
    const nextErrors = {};
    if (!String(user_name || "").trim()) nextErrors.user_name = "Required";
    if (!String(user_email || "").trim()) nextErrors.user_email = "Required";
    if (!String(user_postcode || "").trim()) nextErrors.user_postcode = "Required";
    if (!String(user_mobile_number || "").trim()) nextErrors.user_mobile_number = "Required";
    setFieldErrors(nextErrors);
    if (missing.length) {
      showMissingToast(missing);
      return;
    }
    postEvaluationCreate({
      car: step1?.variant?.current?.value,
      Mileage: mileage.current.title,
      reg_number,
      Previous_owners: previous_owners.current?.id,
      Service_history: services_history.current?.id,
      Website_user: user_name,
      Email: user_email,
      Postcode: user_postcode,
      Mobile_number: user_mobile_number,
    });
    scrollTop();
  };

  const history = useHistory();



  const location = useLocation();

useEffect(() => {

   


  if(location.state){
    setinputshow(true)

     // result: 'some_value'

    setreg_number(location.state.Car_Reg_N)
  }





}, [location])

var dis="enabled"

const [inputshow, setinputshow] = useState(false)



  return (
    <>
      {/* ============================== step 2 form ============================== */}
      {currentStep === 2 ? (
        <Form
          onSubmit={step2OnSubmitHandler}
          buttonText="Continue"
          className={formanimationClassname}
        >
          {/* Registration Number*/}


          {
            inputshow?
           

           
            <IconInput
           
            loading={dis}
            label="Registration Number"
            placeholder="Enter Registration Number"
            onChangeText={setreg_number}
            value={reg_number.toUpperCase()}
          />

            :

<IconInput
     
  
        label="Registration Number"
        placeholder="Enter Registration Number"
        onChangeText={setreg_number}
        value={reg_number.toUpperCase()}
      />


          }
      







          {/* mileage */}
          <IconInput
            label="Mileage"
            placeholder="Enter Mileage"
            onChangeText={(e) =>
              setmileage({
                ...mileage,
                isSelected: e.length > 0,
                current: { id: "", title: e },
              })
            }
            value={normalizeTextField(mileage.current.title)}
          />
          {/* previous_owners */}
          <Dropdown
            label="Previous Owners"
            onSelect={(item) =>
              setprevious_owners({
                ...previous_owners,
                isSelected: true,
                current: item,
              })
            }
            selectedValue={previous_owners.current}
            loading={previous_owners.fetching}
            disabled={false}
            data={[
              { title: "None", id: 7 },
              { title: 1, id: 1 },
              { title: 2, id: 2 },
              { title: 3, id: 3 },
              { title: 4, id: 4 },
              { title:  "5 or more", id: 5 },
              { title: "Don't know", id: 6 },
            ]}
          />
          {/* ======================orinal code  */}
          {/* services_history */}
          <Dropdown
            label="Services History"
            onSelect={(item) =>
              setservices_history({
                ...services_history,
                isSelected: true,
                current: item,
              })
            }
            selectedValue={services_history.current}
            loading={services_history.fetching}
            disabled={false}
            data={[
              { title: "Full", id: 1 },
              { title: "Part", id: 2 },
              { title: "None", id: 3 },
              { title: "First not Due", id: 4 },
            ]}
          />
          {services_history.isSelected && (
            <div style={{ margin: "0 1rem" }}>
              {renderServiceHistoryDetail(services_history.current.title)}
            </div>
          )}
        </Form>
      ) : null}
      {/* ============================== step 3 form ============================== */}
      {currentStep === 3 ? (
        <Form
          onSubmit={postEvaluationCreateHandler}
          buttonText="Get my valuation"
          className={formanimationClassname}
          loading={loading_evaluation_create}
          loadingText="Getting your valuation ..."
        >
          {/* uesr name */}
          <IconInput
            loading={loading_evaluation_create}
            label="Your Name"
            placeholder="Your Name"
            onChangeText={setuser_name}
            value={user_name}
          />
          {/* uesr email */}
          <IconInput
            loading={loading_evaluation_create}
            type="email"
            label="Your Email"
            placeholder="Your Email"
            onChangeText={setuser_email}
            value={user_email}
          />
          {/* uesr postcode */}
          <IconInput
          
          style={{ TextTransform:upperCase}}
            loading={loading_evaluation_create}
            label="Your Postcode"
            placeholder="Your Postcode"
            onChangeText={setuser_postcode}
            value={user_postcode.toUpperCase()}
          />
          {/* uesr mobile_number */}
          <IconInput
            loading={loading_evaluation_create}
            label="Your Mobile Number"
            placeholder="Your Mobile Number"
            onChangeText={setuser_mobile_number}
            value={user_mobile_number}
          />
        </Form>
      ) : null}
      <div className="w-100" style={{ padding: "0.5rem" }}>

      {/* {currentStep === 8 && (
          <Step8 formanimationClassname={formanimationClassname} />
        )} */}

        {currentStep === 4 && (


history.push("/dealers/carsteps")

          // <Step4 formanimationClassname={formanimationClassname} />
        )}
        {/* {currentStep === 5 && (
          <Step5 formanimationClassname={formanimationClassname} />
        )}
        {currentStep === 6 && (
          <Step6 formanimationClassname={formanimationClassname} />
        )}
        {currentStep === 7 && (
          <Step7 formanimationClassname={formanimationClassname} />
        )}
       */}
      </div>
      {/* <button onClick={() => setcurrentStep(currentStep - 1)}>Back</button>
      <button onClick={() => setcurrentStep(currentStep + 1)}>forward</button> */}
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  loading_evaluation_create: state.sellMyCar.loading,
  step1: state.sellMyCar.step1,
  reg_number: state.sellMyCar.step2.reg_number,
  mileage: state.sellMyCar.step2.mileage,
  previous_owners: state.sellMyCar.step2.previous_owners,
  services_history: state.sellMyCar.step2.services_history,
  // step 3 user info
  user_name: state.sellMyCar.user.name,
  user_email: state.sellMyCar.user.email,
  user_postcode: state.sellMyCar.user.postcode,
  user_mobile_number: state.sellMyCar.user.mobile_number,
});
const mapDispatchToProps = (dispatch) => ({
  setmileage: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "mileage",
        data,
      },
    }),
  setprevious_owners: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "previous_owners",
        data,
      },
    }),
  setservices_history: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "services_history",
        data,
      },
    }),
  setreg_number: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "reg_number",
        data,
      },
    }),
  // step 4
  setuser_name: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_name",
        data,
      },
    }),
  setuser_email: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_email",
        data,
      },
    }),
  setuser_postcode: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_postcode",
        data,
      },
    }),
  setuser_mobile_number: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "user_mobile_number",
        data,
      },
    }),
  // post EVALUATION_CREATE
  postEvaluationCreate: (data) => {
    const token = getAuth()?.token;
    return dispatch({
      type: EVALUATION_CREATE,
      payload: {
        type: EVALUATION_CREATE,
        method: POST,
        label: `${Labels.evaluation_create}`,
        hideOverlayLoader: true,
        header: token ? { Authorization: `Token ${token}` } : undefined,
        data,
      },
    });
  },
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: data,
    }),
  updateAuth: (payload) =>
    dispatch({
      type: UPDATE_AUTH,
      payload: { ...(payload || {}) },
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(EvaluationSteps);
